// "use client";
// import { useEffect, useState } from "react";

// export default function useIsTouchDevice() {
//   const [isTouch, setIsTouch] = useState(false);

//   useEffect(() => {
//     if (typeof window !== "undefined") {
//       setIsTouch("ontouchstart" in window || navigator.maxTouchPoints > 0);
//     }
//   }, []);

//   return isTouch;
// }

"use client";
import { useEffect, useState } from "react";

const useIsTouchDevice = () => {
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    const hasTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    const isMobileOrTablet = /Mobi|Android|iPhone|iPad|iPod/i.test(
      navigator.userAgent,
    );
    setIsTouch(hasTouch && isMobileOrTablet);
  }, []);

  return isTouch;
};
export default useIsTouchDevice;